export default __webpack_public_path__ + "static/media/home-header-1.5f6aa837.jpg";